<template>
    <div class="MuiAutocomplete-root MuiAutocomplete-hasClearIcon css-d1kud3">
        <div class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-x4yv5h">
            <div class="MuiInputBase-root MuiFilledInput-root MuiFilledInput-underline MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiAutocomplete-inputRoot css-qvr393">
                <select v-model="val" id="masterBody_ucOwners_dpLegalEntityTypeCode"
                        data-class="md-select md-form"
                        class="MuiInputBase-input MuiFilledInput-input MuiInputBase-inputAdornedEnd MuiAutocomplete-input MuiAutocomplete-inputFocused css-ftr4jk"
                >
                    <option value="">{{ label }}</option>
                    <option v-for="(item, key) in items" :value="key">{{ item }}</option>
                </select>
            </div>
            <p v-if="is_error" class="sc-dPwPAC iFySEt MuiTypography-root MuiTypography-body1 sc-eGbavc eypHHc">{{ text_error }}</p>
        </div>
    </div>
</template>
<script>
	export default {
	    props: {
            is_error: String,
            text_error: String,
            label: String,
            items: Array,
            modelValue: String,
        },
        computed: {
            val: {
                get() {
                    return this.modelValue
                },
                set(val) {
                    this.$emit('update:modelValue', val)
                }
            }
        }
	}
</script>
